
angular.module('bmsApp.directives')
	.directive('notes', [
		'$modal',
		'$ngBootbox',
		'notify',
		'NoteSvc',
		'ConfigService', function (
			$modal,
			$ngBootbox,
			notify,
			NoteSvc,
			ConfigService) {
			return {
				restrict: 'E',
				scope: {
					objectType: '=',
					objectId: '=',
					dropzone: '=',
					noteapi: '='
				},
				replace: true,
				templateUrl: 'ng/notes/templates/NoteList.html',
				link: function (scope, element, attrs) {
					scope.noteapi = {
						showNotes: function () {
							//scope.$broadcast('showNotes');
						},
						showForm: function () {
							scope.showNoteForm();
						},
					};

					scope.$watchGroup(['objectType', 'objectId'], function(newValues, oldValues, scope) {
						scope.$broadcast('showNotes');
					});
				},
				controller: function ($scope) {
					$scope.config = ConfigService.config;

					$scope.showNoteForm = function (note) {
						var modalInstance = $modal.open({
							animation: true,
							templateUrl: 'ng/notes/templates/NoteForm.html',
							controller: 'NoteFormCtrl',
							size: 'lg',
							scope: $scope,
							backdrop: 'static', // disable click-outside closing modal
							resolve: {
								note: function () {
									var newNote = {};
									if (note) {
										angular.extend(newNote, angular.copy(note));
										//return angular.copy(note);
									}
									angular.extend(newNote, {
										object_type: $scope.objectType,
										object_id: $scope.objectId
									});
									return newNote;
								}
							}
						});

						modalInstance.result.then(function (result) {
							if (result.success) {
								switch (result.action) {
									case 'create':
										message = 'Note created successfully';
										break;
									case 'update':
										message = 'Note updated successfully';
										break;
									default:
										message = 'Success';
										break;
								}
								notify({
									message: message
								});
								$scope.$broadcast('notesUpdated');
							}
							else {
								notify({
									message: result.error,
									classes: 'error'
								});
							}
						}, function () {
							// closed
						});

					};

					$scope.noteDelete = function (note) {
						$ngBootbox.confirm('Delete note "' + note.subject + '"?')
							.then(function () {
								NoteSvc.delete(note)
									.then(function (response) {
										notify({
											message: 'Note deleted successfully'
										});
										$scope.$broadcast('notesUpdated');
									}, function (error) {
										notify({
											message: 'Note deleted successfully',
											classes: 'error'
										});
										$log.error(error);
									});
							});
					};
				}
			};
		}]);
